export const clampNegativeToZero = (value: number) => Math.max(0, value);

export const sanitizeOptimization = (value: number | null) =>
  value === null ? null : clampNegativeToZero(value);

export const percentageValueOrNull = (value: number | null) =>
  value === null ? null : value * 100;
